<template>
  <div>
    <header :class="{backColorA: bCb}">
      <div class="top_l">
        <i class="icon-logo" v-if="!isPrivate"></i>
        <i class="icon-logo icon-private" v-else></i>
        <el-tooltip class="item" effect="dark" :content="isBack_ ? '返回项目列表' : '返回任务列表'" placement="bottom">
          <!-- <i class="el-icon-back"></i> -->
          <i class="icon-back" @click="backtrack"></i>
        </el-tooltip>
        <el-tooltip effect="dark" :content="taskName_" placement="bottom">
          <p>{{ taskName_ }}</p>
        </el-tooltip>
        <span class="saveHint">
          <img :src="saveSrc(saveHint_)" style="display: inline-block; vertical-align: middle;" alt />
          {{ saveHint_ }}
        </span>
        <p>原文字数 {{ wordNum_ }}字</p>
        <span class="progressBox" v-if="transStatus_ !== 2">
          {{progress_|| 0}}%
        </span>
      </div>
      <div class="top_r">
        <el-select v-model="interspace" placeholder @change="changeCompany" v-if="region.length > 1 && !$privatization"
          :value="interspaceVal">
          <el-option v-for="(item, index) in region" :label="getLabel(item)" :key="index" :value="item.code">
          </el-option>
        </el-select>
        <el-tooltip effect="dark" content="用户中心" placement="bottom">
          <a class="pointer" @click="toUserConter('perCenter')">
            <img v-if="!$privatization" :src="userImg" alt />
            <img v-if="$privatization" src="../../../assets/imgs/home/moren_tx.png" alt />
            <span class="pointer">{{ userName }}</span>
          </a>
        </el-tooltip>
        <el-tooltip effect="dark" content="退出登录" placement="bottom">
          <span class="out" style="cursor:pointer;" @click="isOut"></span>
        </el-tooltip>
      </div>
    </header>
    <messageBox v-if="mesBox" :isShow="mesBox" tit="友情提示" txt="确定退出登录吗？" :imgSrc="imgSrc" @message="empty"
      @messageIf="messageIf"></messageBox>
  </div>
</template>

<script>

import messageBox from "@/common/messageBox.vue";
export default {
  props: ["isBack", "saveHint", "bCb", "progress", "queryData"],
  name: "editorHeader",
  data () {
    return {
      taskName_: this.queryData.taskName,
      wordNum_: this.queryData.wordNum,
      transStatus_: this.queryData.transStatus,
      interspace: "",
      interspaceVal: "",
      userName: "",
      userImg: "",
      bCb_: this.bCb,
      backColorA: "",
      region: "",
      mesBox: false,
      imgSrc: require("../../../assets/imgs/project/qr_code_bg.png"), // 弹窗title背景图
      isPrivate:IS_PRIVATE
    }
  },
  components: {
    messageBox
  },
  computed: {
    saveHint_: function () {
      return this.saveHint
    },
    isBack_: function () {
      return this.isBack
    },
    progress_: function () {
      return this.progress;
    },
  },
  created () {
    let myUser = localStorage.getItem("myUser");
    if (!myUser) {
      this.$router.push({ name: "login" });
    }
    myUser = JSON.parse(myUser); //把字符串转换成JSON对象
    const lastSelectCompany = JSON.parse(localStorage.lastSelectCompany);
    this.region = myUser.companyList; // 空间数组
    let role = lastSelectCompany.role;
    if (role) {
      this.interspace = `${lastSelectCompany.name}(${role.name})`;
    } else {
      this.interspace = `${lastSelectCompany.name}`;
    } // 默认选中空间   ///
    // this.value = this.$store.state.setCompanyCode
    this.userImg = localStorage.getItem("myUserImg"); // 头像
    this.userName = localStorage.getItem("myUserName"); // 昵称
  },
  methods: {
    toUserConter(name) {
      if (this.$independence) {
        this.$router.push({
          path: "/home/userConter",
          query: {
            activeName:"first"
          }
        })
      } else {
        window.open(PTURL + name)
      }
    },
    // 返回上一页
    backtrack () {
      if (this.isBack_) {
        this.$router.push({ name: "fileList" });
      } else {
        this.$router.push({ name: "myTask" });
      }
    },
    getLabel (item) {
      if (item.role) {
        return `${item.name}(${item.role.name})`;
      } else {
        return `${item.name}`;
      }
    },
    // 保存动态图片
    saveSrc (saveHint) {
      switch (saveHint) {
        case "正在自动保存...":
          return require("../../../assets/imgs/editor/save.png");
          break;
        case "自动保存成功！":
          return require("../../../assets/imgs/editor/successful_preservation.png");
          break;
        case "自动保存失败！":
          return require("../../../assets/imgs/editor/failure.png");
          break;
        default:
          break;
      }
    },
    // 切换空间
    changeCompany (query) {
      let that = this;
      // that.$store.state.myCompanyCode = query;
      localStorage.setItem("myCompanyCode", query);
      that.$store.commit("setCompanyCode", query);
      this.catReq1Service("/api/v1/user/changeCompany", { code: query }).then(
        function (response) {
          if (!response.success) {
            return;
          }
          if (response.success === true) {
            let data = response.result;
            let val = JSON.stringify(data);
            localStorage.setItem("myUser", val);
            // localStorage.setItem("myId", data.id);
            // localStorage.setItem("myUserImg", data.avatar); // 头像
            // localStorage.setItem("myUserName", data.nickName); // 昵称
            // localStorage.setItem("myAliasName", data.aliasName); // 别名
            that.$router.push({ name: "homeMiddleware" });
          }
        }
      );
    },
    // 退出登录弹窗
    isOut () {
      this.mesBox = true;
    },
    messageIf () {
      if (this.mesBox) {
        this.mesBox = false;
      } else {
        this.mesBox = true;
      }
    },
    empty () {
      if (this.$independence) {
        let that = this;
        this.catReq1Service("/user/ajaxLogout").then(function (response) {
          if (response.resultCode === "1") {
            that.$router.push({ name: "login" });
          }
        });
        return
      } else {
        localStorage.removeItem('myHeaderUser');
        localStorage.removeItem('myUser');
        let callback = encodeURIComponent(`${window.location.origin}/logout?client_name=${process.env.VUE_APP_CLIENT_NAME}`)
        window.location.href = `${CASURL}/logout?service=${callback}`;
      }
    }
  },
}
</script>
<style lang="less" scoped>
header {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 9px 0px rgba(235, 246, 241, 1);
  height: 50px;
  // width: 100%;
  .pointer:hover{
    cursor: pointer;
  }
  .top_l {
    float: left;
    // width: 300px;
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 14px;
    color: #424242;
    .icon-logo {
      display: inline-block;
      width: 35px;
      height: 35px;
      margin-left: 30px;
      background: url("../../../assets/imgs/editor/bz_logo.png") no-repeat center center;
      background-size: contain;
    }
    .icon-private{
      background: url("/static/edit_def_logo.png") no-repeat center center;
      background-size: contain;
    }
    .icon-back {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin: 0 20px;
      cursor: pointer;
      background: url("../../../assets/imgs/editor/bz_fh_normal.png") no-repeat;
    }
    .icon-back:active{
      background: url("../../../assets/imgs/editor/bz_fh_press.png") no-repeat;
    }
    .saveHint {
      //  line-height: 20px;
      margin-left: 20px;
    }
    .progressBox {
      margin-left: 20px;
      display: inline-block;
      width: 60px;
      height: 16px;
      line-height: 16px;
      font-size: 12px;
      background: rgba(92, 142, 246, 1);
      color: white;
      text-align: center;
    }
    button {
      float: left;
      width: 48px;
      height: 30px;
      background: rgba(102, 102, 102, 1);
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      color: white;
      font-size: 18px;
      margin: 0 20px;
    }
    p {
      max-width: 320px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .top_r {
    float: right;
    line-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/.el-input {
      width: 160px;
    }
    // position: relative;
    .el-select {
      margin-right: 20px;
      .el-input {
        width: 160px;
      }
    }
    img {
      border-radius: 50%;
    }
    input {
      // width: 160px;
      height: 36px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(186, 185, 185, 1);
      border-radius: 2px;
    }
    a {
      margin-right: 40px;
      img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
      span {
        margin-left: 20px;
        width: 47px;
        height: 11px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
    .out {
      width: 18px;
      height: 20px;
      margin-right: 60px;
      background: url("../../../assets/imgs/project/sign_out_normal.png");
    }
    .out :hover {
      background: url("../../../assets/imgs/project/sign_outhover.png");
    }
    .out :active {
      background: url("../../../assets/imgs/project/sign_out_press.png");
    }
  }
}
.backColorA {
  background: rgba(48, 51, 60, 1) !important;
  box-shadow: 0px 0px 0px 0px !important;
  .top_l {
    color: white;
    .icon-logo{
      background: url("../../../assets/imgs/editor/yj_logo.png") no-repeat center center;
      background-size: contain;
    }
    .icon-private{
      background: url("/static/edit_def_logo.png") no-repeat center center;
      background-size: contain;
    }
    .icon-back{
      background: url("../../../assets/imgs/editor/yj_fh_press.png") no-repeat;
    }
  }
  .top_r {
    /deep/.el-select {
      /deep/.el-input__inner {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }
    }
    span {
      color: #fff !important;
    }
  }
  //   /deep/.el-progress-bar__outer {
  //     background-color: #4d515f !important;
  //   }
  //   /deep/.el-progress-bar__inner {
  //     background: #507383 !important;
  //   }
  /*下拉框颜色*/
  /deep/.el-popper {
    /deep/.el-scrollbar {
      /deep/.el-scrollbar__view {
        /deep/.el-select-dropdown__item {
          background: #507383 !important;
        }
        background: #507383 !important;
      }
    }
  }

  /deep/.el-select {
    /deep/.el-input__inner {
      background: #507383 !important;
      border: none !important;
      color: white !important;
    }
  }
}
</style>